import React from 'react';
import ReactDOM from 'react-dom';
import {changeAvatar, changeToDefaultAvatar} from './avatar-changer';

import MediaUploader from '../react-components/MediaUploader/MediaUploader.jsx';

//function uploaderCreation() {
//    const uploader = new Upload('client-upload');
//    uploader.renderLoader();
//}


function setMediaUploader(id) {

    var convertType = function (value){
        var v = Number (value);
        return !isNaN(v) ? v :
             value === "undefined" ? undefined
           : value === "null" ? null
           : value === "true" ? true
           : value === "false" ? false
           : value
     };

    let root = document.getElementById(id),
        rootUploaded = JSON.parse(root.getAttribute('data-uploaded')),
        rootId = JSON.parse(root.getAttribute('data-id')),
        rootData = {
            type: root.getAttribute('data-filter'),
        },
        rootMediaType = root.getAttribute('data-uploader-type');

    const handleAvatarChange = (upload) => {
        changeAvatar(rootData.type, upload);
    };

    const handleDeleteAvatar = () => {
        changeToDefaultAvatar(rootData.type);
    };



    ReactDOM.render(<MediaUploader id={convertType(rootId)}
                                   filter={convertType(root.getAttribute('data-filter'))}
                                   path={convertType(rootUploaded.path)}
                                   cropPath={convertType(rootUploaded["crop-path"])}
                                   reference={convertType(rootUploaded.ref)}
                                   uploaderType={rootMediaType}
                                   hash={convertType(rootUploaded.hash)}
                                   onUpload={(value)=>handleAvatarChange(value)}
                                   onCrop={(value)=>handleAvatarChange(value)}
                                   onDelete={()=>handleDeleteAvatar()}
    />
    , root);
}

function init() {
    if (document.getElementById('media-uploader') !== null) {
        setMediaUploader('media-uploader')
    }
    if(document.getElementById('logo-uploader')!== null) {
        setMediaUploader('logo-uploader')
    }
    if(document.getElementById('avatar-uploader')!== null) {
        setMediaUploader('avatar-uploader')
    }
}

export{ init }


// WEBPACK FOOTER //
// ./src/_app/clients-upload/clients-upload.js